import { atom } from 'jotai'
import { ExcelPlanResponse, OptimizePlanRequest } from '@/api'
import { NormalizedOptimizePlanResponse } from '@/utils/normalizeOptimizeResponse'

export const excelPlanResponseAtom = atom<ExcelPlanResponse | null>(null)
export const optimizePlanRequestAtom = atom<OptimizePlanRequest | null>(null)
export const optimizePlanResponseAtom = atom<NormalizedOptimizePlanResponse | null>(null)
export const originalPlanResponseAtom = atom<NormalizedOptimizePlanResponse | null>(null)
export const lastOptimizeMethodAtom = atom<OptimizePlanRequest.optimize | null>(null)

